var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockOpen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M8.571 7V5.286A4.287 4.287 0 0 0 4.286 1 4.287 4.287 0 0 0 0 5.286V6.6c0 .22.18.4.4.4h.828a.4.4 0 0 0 .4-.4V5.286a2.66 2.66 0 0 1 2.658-2.657 2.66 2.66 0 0 1 2.657 2.657V7H5.02a1.72 1.72 0 0 0-1.714 1.714v8.572A1.72 1.72 0 0 0 5.02 19h10.286a1.72 1.72 0 0 0 1.714-1.714V8.714A1.72 1.72 0 0 0 15.306 7H8.571Zm-.122 6a1.72 1.72 0 0 0 1.714 1.714A1.72 1.72 0 0 0 11.878 13a1.72 1.72 0 0 0-1.715-1.714A1.72 1.72 0 0 0 8.45 13Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock-open.285740c40d658d5a8fcaf3b18c2e20e6.svg";